import _ from "lodash";
import { WorkspaceAsset, WorkspaceRoutine } from "@gripp/shared-logic";

/*
  Extracts routines from both the product and groups associated with the workspace asset,
  removes duplicates based on routine ID, and sorts them by their order property.
*/
export const extractAndDeduplicateRoutines = (workspaceAsset: WorkspaceAsset): WorkspaceRoutine[] => {
  const productRoutines = workspaceAsset.asset?.product?.routines || [];
  const allActiveProductRoutines = productRoutines.filter((r) => !r.deactivated);

  const groupRoutines = workspaceAsset.groups?.flatMap(g => g.routines) || [];
  const allActiveGroupRoutines = groupRoutines.filter((r) => r && !r.deactivated);

  return _
    .uniqBy(
      [...allActiveGroupRoutines, ...allActiveProductRoutines], 
      'id'
    )
    .sort((a: WorkspaceRoutine, b: WorkspaceRoutine) => {
      return a.order - b.order;
    });
};
    